import {
  beFiltersApiCheckCategoryName,
  beFiltersApiCheckCategoryUse,
  beFiltersApiCreateCategory,
  beFiltersApiDeleteCategory,
  beFiltersApiEditCategory,
  beFiltersApiGetCategoryById,
  beFiltersApiGetPagedCategories,
} from 'Api/beFiltersApi'
import {
  type CheckCategoryUsage,
  type Category,
  type CategoryPagedListQuery,
  type PagedList,
} from 'Types/beFiltersApi'

export const getCategories = async (
  query: CategoryPagedListQuery,
): Promise<PagedList<Category>> => {
  return await beFiltersApiGetPagedCategories(query)
}

export const getCategory = async (id: number): Promise<Category> => {
  return await beFiltersApiGetCategoryById(id)
}

export const createCategory = async (name: string): Promise<Category> => {
  return await beFiltersApiCreateCategory(name)
}

export const editCategory = async (category: Category): Promise<Category> => {
  return await beFiltersApiEditCategory(category)
}

export const checkCategoryUse = async (
  idCategory: number,
): Promise<CheckCategoryUsage[]> => {
  return await beFiltersApiCheckCategoryUse(idCategory)
}

export const checkCategoryNameAlreadyExists = async (
  name: string,
  id?: number,
): Promise<boolean> => {
  const req = {
    Name: name,
    IdToExclude: id,
  }
  return (await beFiltersApiCheckCategoryName(req)).Exists
}

export const deleteCategory = async (idCategory: number): Promise<boolean> => {
  return await beFiltersApiDeleteCategory(idCategory)
}
